import { render, staticRenderFns } from "./Sharing.vue?vue&type=template&id=22fe0eaa&scoped=true&"
import script from "./Sharing.vue?vue&type=script&setup=true&lang=js&"
export * from "./Sharing.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fe0eaa",
  null
  
)

export default component.exports